<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="page.isNew && $check(user, ['reportfiles.create'])" type="button" elevation="0"
                            color="primary" @click=create()>Salvar</v-btn>
                        <v-btn v-if="!page.isNew && $check(user, ['reportfiles.update'])" type="button" elevation="0"
                            color="primary" @click=update()>Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/arquivo-relatorio">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense id="name" label="Nome" v-model="dataset.data.name"
                                                required :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-select dense :items="dataset.reportTypes" item-value="id"
                                                item-text="name" v-model="dataset.data.report_type_id"
                                                label="Modelo de Relatório" outlined hide-details="auto"
                                                :disabled="!page.isNew && dataset.data.status != 1"></v-select>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-select dense :items="dataset.clients" item-value="id" item-text="name"
                                                v-model="dataset.data.client_id" label="Caso" outlined
                                                :disabled="!page.isNew && dataset.data.status != 1" hide-details="auto"></v-select>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-row text-align="center">
                                    <v-col cols="12">
                                        <v-card class="card-form-outlined">
                                            <v-row justify="center" align="center">
                                                <v-col>
                                                    <v-card-title class="card-group-title">Arquivo</v-card-title>
                                                </v-col>
                                            </v-row>
                                            <v-card-text v-if="page.isNew">
                                                <v-row>
                                                    <v-col cols="12">
                                                        <div v-bind="$attrs" class="upload-area"
                                                            @dragover.prevent="handleDragOver"
                                                            @drop.prevent="handleFileDrop" @click="triggerFileInput">
                                                            <v-icon class="upload-icon">mdi-cloud-upload</v-icon>
                                                            <p class="upload-text">Arraste e solte seu arquivo aqui
                                                                ou clique
                                                                para
                                                                selecionar</p>
                                                        </div>
                                                        <input ref="fileInput" type="file" style="display: none"
                                                            @change="handleFileChange" />
                                                        <v-alert v-if="dataset.data.file" type="success" class="mt-4">
                                                            Arquivo selecionado: {{ dataset.data.file.name }}
                                                        </v-alert>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                            <v-card-text v-if="dataset.data.resource">
                                                <v-row>
                                                    <v-col>
                                                        <v-icon>mdi-file</v-icon>
                                                        <span class="ml-2">{{ dataset.data.resource.name }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>

                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>

<script>
import axios from "axios"

export default {
    name: "ReportFileDetails",

    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        rule: {
            column1: '',
            operator: '',
            column2: ''
        },
        operators: ['+', '-', '*', '/'],
        dataset: {
            reportTypes: [],
            clients: [],
            breadcrumbItems: [],
            loading: false,
            data: {
                file: null
            },
        },
        dataForm: {
            validForm: true,
            addLoading: false,
        },
    }),

    created() {
        this.setPage();
        this.listBreadCrumbItems();
        this.loadData();
    },

    computed: {
        fileRule() {
            return v => (v && v.size <= 314572800) || 'O arquivo deve ser menor que 300MB';
        },
    },

    methods: {

        goBack() {
            this.$router.replace("/arquivo-relatorio");
        },

        async loadData() {
            this.user = this.$root.user.data || this.$root.user;

            await this.loadReportTypes();
            await this.loadClients();
            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page && this.page.isNew ? "Criar relatório" : "Detalhes do relatório";
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Relatórios",
                disabled: false,
                to: "/modelo-relatorio",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async load() {
            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/report-files/${this.$route.params.id}`);

                this.dataset.data = result.data.content;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async loadReportTypes() {
            try {
                const result = await axios.get(`/api/admin/report-types`, { params: { limit: 1000 } });

                this.dataset.reportTypes = result.data.content.data;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async loadClients() {
            try {
                const result = await axios.get(`/api/clients`, { params: { limit: 1000 } });

                this.dataset.clients = result.data.content.data;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async uploadFile() {
            const formData = new FormData()
            formData.append('file', this.dataset.data.file)

            try {
                const response = await axios.post('/api/admin/resources', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })

                this.dataset.data.resource_id = response.data.content.id
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 })
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados do relatório?',
                title: 'Atualizar relatório',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar',
                },
            });

            if (!proceedAction) return;

            const payload = await this.buildPayload();

            console.log("payload: ", payload)

            try {
                const response = await axios.patch(`/api/admin/report-files/${this.$route.params.id}`, payload, {
                    headers: { 'Content-Type': 'application/json' },
                });

                this.$dialog.notify.info('Relatório atualizado com sucesso!', {
                    position: 'top-right',
                    timeout: 2000,
                });

                this.goBack();
            } catch (error) {
                this.$dialog.notify.error('Erro ao atualizar o relatório.', {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },

        async create() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja criar um novo relatório?',
                title: 'Criar modelo',
                actions: {
                    false: 'Cancelar',
                    true: 'Criar',
                },
            });

            if (!proceedAction) return;

            await this.uploadFile();

            const payload = await this.buildPayload();

            console.log('payload', payload);

            try {
                const response = await axios.post('/api/admin/report-files', payload, {
                    headers: { 'Content-Type': 'application/json' },
                });

                this.$dialog.notify.info('Relatório criado com sucesso!', {
                    position: 'top-right',
                    timeout: 2000,
                });

                this.goBack();
            } catch (error) {
                // TODO: melhorar
                this.$dialog.notify.error('Erro ao criar o relatório.', {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },


        async buildPayload() {
            return {
                name: this.dataset.data.name,
                report_type_id: this.dataset.data.report_type_id,
                resource_id: this.dataset.data.resource_id,
                client_id: this.dataset.data.client_id
            };
        },

        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleDragOver(event) {
            event.stopPropagation();
            event.preventDefault();
            // Para mostrar visualmente que a área pode receber o arquivo
            event.target.classList.add("dragging");
        },

        handleFileDrop(event) {
            event.stopPropagation();
            event.preventDefault();
            const file = event.dataTransfer.files[0];
            if (file) {
                this.dataset.data.file = file;
            }
            event.target.classList.remove("dragging");
        },

        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.dataset.data.file = file;
            }
        },
    },

};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.main-text {
    font-size: 16px;
    color: #000;
}

.caption-text2 {
    font-size: 12px;
    font-weight: bold;
    color: #444;
    margin-top: -5px;
}

.upload-area {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 200px;
    border: 2px dashed var(--v-primary-base);
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    position: relative;
    transition: background-color 0.3s;
}

.upload-area:hover {
    background-color: #f5f5f5;
}

.upload-area.dragging {
    background-color: #e3f2fd;
}

.upload-icon {
    font-size: 48px;
    color: var(--v-primary-base);
}

.upload-text {
    margin-top: 12px;
    font-size: 16px;
    color: var(--v-primary-base);
}

.v-alert {
    margin-top: 16px;
}
</style>